var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08829 7.5C9.08829 8.655 8.15495 9.58833 6.99995 9.58833C5.84495 9.58833 4.91162 8.655 4.91162 7.5C4.91162 6.345 5.84495 5.41167 6.99995 5.41167C8.15495 5.41167 9.08829 6.345 9.08829 7.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 12.3242C9.05908 12.3242 10.9782 11.1108 12.3141 9.01083C12.8391 8.18833 12.8391 6.80583 12.3141 5.98333C10.9782 3.88333 9.05908 2.67 6.99991 2.67C4.94074 2.67 3.02158 3.88333 1.68574 5.98333C1.16074 6.80583 1.16074 8.18833 1.68574 9.01083C3.02158 11.1108 4.94074 12.3242 6.99991 12.3242Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1f5f482fe6eed6f654b680b247d93314.svg";
export { ForwardRef as ReactComponent };